module.exports = __webpack_public_path__ + "static/media/Coil-Spring_355x237.497d38cd.jpg";